import { useErrorHandler, useExperiments, useHttpClient, useTranslation } from '@wix/fe-essentials/react';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { analyzeFullSite as analyzeFullSiteReq } from '../../api/analyze-full-site';
import { resetAllHeadingStructureAIAtom } from '../../atoms/heading-structure-ai-atoms';
import { AnalysisState, usePanelStateAtom } from '../../hooks/rules-state';
import { useA11yDebug } from '../../hooks/use-a11y-debug';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useMapPageIdToPageDataFromServer } from '../../hooks/use-map-page-id-to-page-data-from-server';
import { useSessionInfoContext } from '../../hooks/use-session-info-context';
import { NotPublishedBranchIdError } from '../../types';
import { mapPageIdToPageDataFromServer } from '../../utils/map-page-id-to-page-data-server';
export const useAnalyzeFullSite = () => {
  const {
    initializePanelState,
    setGroupsAnalysisState,
    setPagesData
  } = usePanelStateAtom();
  const resetAllHeadingStructureAI = useSetAtom(resetAllHeadingStructureAIAtom);
  const {
    a11yWizardAdapter,
    capabilities
  } = useA11yWizardAdapter();
  const {
    i18n
  } = useTranslation();
  const {
    experiments
  } = useExperiments();
  const a11yDebug = useA11yDebug();
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  const mapPageIdToPageDataFromServerV2 = useMapPageIdToPageDataFromServer();
  const {
    setPublishedBranchId,
    publishedBranchId: prevPublishedBranchId
  } = useSessionInfoContext();
  const analyzeFullSite = useCallback(async () => {
    setGroupsAnalysisState(AnalysisState.FirstAnalyzing, undefined, true);
    try {
      const savePromise = experiments.enabled('specs.a11y.A11yWizardRmVersion') ? Promise.resolve() : a11yWizardAdapter.triggerEditorSave();
      const [publishedBranchId] = await Promise.all([a11yWizardAdapter.getPublishedBranchId(), a11yWizardAdapter.reloadSiteProperties(), savePromise, setPagesData(capabilities.compactPanelChrome ? await mapPageIdToPageDataFromServerV2() : await mapPageIdToPageDataFromServer(a11yWizardAdapter, i18n, httpClient, errorHandler))]);
      if (publishedBranchId !== prevPublishedBranchId) {
        setPublishedBranchId(publishedBranchId);
        throw new NotPublishedBranchIdError('Published branch id changed', {});
      }
      const response = await analyzeFullSiteReq(httpClient, errorHandler);
      a11yDebug.addAnalyzeResponse == null || a11yDebug.addAnalyzeResponse(response);
      initializePanelState();
      resetAllHeadingStructureAI();
      return response.data.jobs ?? [];
    } catch (error) {
      setGroupsAnalysisState(AnalysisState.AnalyzeFailed, undefined, true);
      throw error;
    }
  }, [setGroupsAnalysisState, experiments, a11yWizardAdapter, capabilities.compactPanelChrome, setPagesData, mapPageIdToPageDataFromServerV2, i18n, httpClient, errorHandler, prevPublishedBranchId, a11yDebug, initializePanelState, resetAllHeadingStructureAI, setPublishedBranchId]);
  return {
    analyzeFullSite
  };
};
//# sourceMappingURL=use-analyze-full-site.js.map